import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Experience } from '../experience.model';
import { ExperiencesService } from '../experiences.service';
import {environment} from '../../../../environments/environment';
import { ToastyService } from 'ng2-toasty';

@Component({
  selector: 'app-all-experiences',
  templateUrl: './all-experiences.component.html',
  styleUrls: ['./all-experiences.component.scss']
})
export class AllExperiencesComponent implements OnInit {

  experiences$: Observable<{data: Experience[]}>;
  environment = environment;

  constructor( private expService: ExperiencesService, private toastyService: ToastyService) { }

  ngOnInit(): void {
    this.experiences$ = this.expService.getAllExperiences();
  }

  /* toggleDropdown(id: number): void {
    if (document.getElementById('dropdown'+id).classList.contains('active')) {
      document.getElementById('dropdown'+id).classList.remove('active');
      document.getElementById('exp-'+id).classList.remove('active');
    } else {
      document.getElementById('dropdown'+id).classList.add('active');
      document.getElementById('exp-'+id).classList.add('active')
    }
  } */

  deleteExperience(id: number): void {
    this.experiences$.subscribe((res) => {
      this.expService.changeStatus(res.data.find(exp => exp.id = id).id, 'deleted')
      .subscribe((res) => {
        this.experiences$ = this.expService.getAllExperiences();
        this.toastyService.success({
          title: 'Experience eliminata'
        });
      },
      (err) => {
        console.log('Errore ', err.error.message);
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
